import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Input, Button } from "reactstrap";
function AssetsgalleryImges(props) {
  var [activeTab, setActiveTab] = useState("All");
  // const handleReplaceImages = (img) => {
  //   props.setSelectedImages(img)
  // }
  const handleReplaceImages = (img) => {
    if (props.selectedImages && props.selectedImages.fileId === img.fileId) {
      props.setSelectedImages(null);
      if (props.onUnselect) props.onUnselect();
    } else {
      props.setSelectedImages(img);
    }
  }
  var galleryImg = props.galleryImg || [];
  var allSubCategories = props.allSubCategories || [];

  var tabs = [{ label: "All", count: galleryImg.length }];
  if (allSubCategories.length > 0) {
    allSubCategories.forEach(function (sub) {
      tabs.push({ label: sub.assetSubCategoryLabel, count: sub.count || 0 });
    });
  } else {
    var seen = {};
    galleryImg.forEach(function (asset) {
      var label = asset.assetSubCategoryLabel || "Other";
      seen[label] = (seen[label] || 0) + 1;
    });
    Object.keys(seen).forEach(function (label) {
      tabs.push({ label: label, count: seen[label] });
    });
  }

  useEffect(function () {
    setActiveTab("All");
  }, [props.galleryImg]);

  var filteredGallery = activeTab === "All"
    ? galleryImg
    : galleryImg.filter(function (asset) {
        return (asset.assetSubCategoryLabel || "Other") === activeTab;
      });


  return (
    <>
      <div className='asset-gallery-header' style={{ alignItems: "flex-start" }}>
      <div className="brand-tabs d-flex align-items-center flex-wrap" style={{ flex: 1, rowGap: "12px" }}>
      {tabs.map(function (tab) {
            var isActive = tab.label === activeTab;
            var displayLabel = tab.label.replace(/^Media\s*-\s*/i, "");
            return (
              <div
                key={tab.label}
                className={"main-tabs" + (isActive ? " active" : "")}
                onClick={function () { setActiveTab(tab.label); }}
                style={{ cursor: "pointer" }}
              >
                {displayLabel}
                <span className="tab-count"> ({tab.count})</span>
              </div>
            );
          })}
        </div>
        <Button
          className='mr-1 btn-background-color'
          disabled={!props.selectedImages || !props.selectedImages.fileId}
          onClick={() => props.handleSubmitFile()}>
          Replace
        </Button>
        {/* <Button onClick={() => handleUpdateFiles()}>
                Add Images
              </Button> */}
      </div>
      <Row className='p-1 mt-3' style={{ minHeight: "465px", maxHeight: "470px", overflowY: "auto" }}>
      {props.loading ? (
          <Col xs={12}>
            <div className="text-center py-5">
              <h5>Loading Images...</h5>
            </div>
          </Col>
            ) : filteredGallery.length > 0 ? (
              filteredGallery.map((asset) => (
            <Col sm={4} md={3} key={asset.fileId}>
              {(() => {
                const isSelected = props.selectedImages && props.selectedImages.fileId === asset.fileId;
                return (
                  <Card
                  onClick={() => handleReplaceImages(asset)}
                  className={"asset-gallery-card" + (isSelected ? " asset-gallery-card-selected" : "")}
                >
                  {/* Checkmark Badge */}
                  {isSelected && (
                    <div className="asset-gallery-checkmark">
                      <span className="asset-gallery-checkmark-icon">✓</span>
                    </div>
                  )}

                  {/* Blue Overlay */}
                  {isSelected && (
                    <div className="asset-gallery-overlay" />
                  )}

                    <img
                      src={asset.filePath}
                      alt="not found"
                      width="100%"
                      height="100%"
                    />
                    <p
                      className={"asset-gallery-filename" + (isSelected ? " asset-gallery-filename-selected" : "")}
                      title={asset.fileName}
                    >
                      {asset.fileName.length > 30
                        ? `${asset.fileName.substring(0, 30)}...`
                        : asset.fileName}
                    </p>
                    <p className=" mt-0 mb-2 d-flex justify-content-center">
                      {/* Image Locator :  */}
                      <b>{asset.imageLocator !== null &&
                        asset.imageLocator !== undefined &&
                        asset.imageLocator !== ''
                          ? String(asset.imageLocator) === '1'
                            ? 'MAIN'
                            : `PT${String(Number(asset.imageLocator) - 1).padStart(2, '0')}`
                          : ''}
                      </b>
                    </p>
                  </Card>
                );
              })()}
            </Col>
          ))) : (
          <Col xs={12}>
            <div className="text-center py-5">
              <h5>No Image Found</h5>
            </div>
          </Col>
        )}
      </Row>

    </>
  )
}
export default AssetsgalleryImges